// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShoppingTwoToneSvg from "@fishx/icons-svg/es/asn/ShoppingTwoTone";
import FishxIcon from '../components/FishxIcon';

var ShoppingTwoTone = function ShoppingTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShoppingTwoToneSvg
  }));
};

ShoppingTwoTone.displayName = 'ShoppingTwoTone';
export default React.forwardRef(ShoppingTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ShoppingTwoTone.js
// module id = 4109
// module chunks = 0